import type {ContextRegionMetaTag} from '@github-ui/global-navigation-types'

// Only these tags are read from or written to the document, so a context refresh can't add or replace other tags.
const REPOSITORY_META_TAG_NAMES = new Set([
  'current-repo-nwo',
  'go-import',
  'octolytics-dimension-user_id',
  'octolytics-dimension-user_login',
])
const REPOSITORY_META_TAG_PREFIX = 'octolytics-dimension-repository_'

function isRepositoryMetaTagName(name: string): boolean {
  return REPOSITORY_META_TAG_NAMES.has(name) || name.startsWith(REPOSITORY_META_TAG_PREFIX)
}

function getRepositoryMetaElements(): HTMLMetaElement[] {
  return [...document.head.querySelectorAll<HTMLMetaElement>('meta[name]')].filter(meta =>
    isRepositoryMetaTagName(meta.name),
  )
}

/** Reads the repository meta tags currently in the document. */
export function readRepositoryMetaTags(): ContextRegionMetaTag[] {
  return getRepositoryMetaElements().map(({name, content}) => ({name, content}))
}

/** Replaces the repository meta tags in the document with `tags`, so they describe the displayed repository. */
export function applyRepositoryMetaTags(tags: readonly ContextRegionMetaTag[]) {
  for (const meta of getRepositoryMetaElements()) meta.remove()

  for (const {name, content} of tags) {
    if (!isRepositoryMetaTagName(name)) continue
    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.append(meta)
  }
}
